/*
  The Bridge: ad landing listicle behaviour (sections/bw-listicle-*.liquid)
  - Progress strip: underline follows the reason in view, bar fills as you read
  - Mobile sticky bar: appears after the hero, hides while the offer is on screen
  - Offer countdown
  Runs on load and again whenever the theme editor re-renders a section.
  Measures everything relative to the viewport, so it works whichever element scrolls.
*/
(function () {
  'use strict';
  // Several sections include this file; only run it once
  if (window.bwListicleLoaded) return;
  window.bwListicleLoaded = true;

  var frame = null;
  var progressNavs = [];
  var stickyBars = [];

  /* ---------- Progress strip ---------- */
  function setupProgress(nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('.bw-li-progress__link'));
    return {
      nav: nav,
      links: links,
      bar: nav.querySelector('.bw-li-progress__bar'),
      list: nav.querySelector('.bw-li-progress__links'),
      current: -1
    };
  }

  function updateProgress(p) {
    if (!p.nav.isConnected) return;
    var navBottom = p.nav.getBoundingClientRect().bottom;
    var line = navBottom + 24;
    var targets = p.links.map(function (link) {
      return document.getElementById(link.getAttribute('data-target'));
    });

    var current = 0;
    targets.forEach(function (t, i) {
      if (t && t.getBoundingClientRect().top <= line) current = i;
    });

    if (current !== p.current) {
      p.current = current;
      p.links.forEach(function (link, i) {
        var on = i === current;
        link.classList.toggle('is-active', on);
        if (on) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      var active = p.links[current];
      if (active && p.list && p.list.scrollWidth > p.list.clientWidth) {
        // Measure relative to the scrolling list itself (offsetLeft is relative to an ancestor,
        // which includes the "In this edit" label and over-scrolls, clipping the first item).
        var listRect = p.list.getBoundingClientRect();
        var linkRect = active.getBoundingClientRect();
        var start = linkRect.left - listRect.left + p.list.scrollLeft;
        var visible = linkRect.left >= listRect.left && linkRect.right <= listRect.right;
        if (current === 0) {
          p.list.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (!visible) {
          p.list.scrollTo({ left: Math.max(0, start - 16), behavior: 'smooth' });
        }
      }
    }

    var first = targets[0];
    var last = targets[targets.length - 1];
    if (p.bar && first && last) {
      var start = first.getBoundingClientRect().top - line;
      var end = last.getBoundingClientRect().bottom - window.innerHeight;
      var total = end - start;
      var pct = total > 0 ? -start / total : 0;
      p.bar.style.width = Math.max(0, Math.min(1, pct)) * 100 + '%';
    }
  }

  /* ---------- Mobile sticky bar ---------- */
  function setupSticky(bar) {
    return {
      bar: bar,
      showAfter: parseInt(bar.getAttribute('data-show-after'), 10) || 600,
      shown: false
    };
  }

  function updateSticky(s) {
    if (!s.bar.isConnected) return;
    var main = document.querySelector('.bw-li');
    // Distance scrolled past the top of the listicle, independent of the scrolling element
    var scrolled = main ? -main.getBoundingClientRect().top : 0;
    var offer = document.querySelector('[data-bw-offer]');
    var offerInView = false;
    if (offer) {
      var r = offer.getBoundingClientRect();
      offerInView = r.top < window.innerHeight && r.bottom > 0;
    }
    var show = scrolled > s.showAfter && !offerInView;
    if (show === s.shown) return;
    s.shown = show;
    s.bar.classList.toggle('is-visible', show);
    s.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    var link = s.bar.querySelector('a');
    if (link) link.setAttribute('tabindex', show ? '0' : '-1');
  }

  /* ---------- Countdown ---------- */
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }

  function startCountdown(el) {
    if (el.getAttribute('data-bw-running')) return;
    var raw = el.getAttribute('data-bw-deadline') || '';
    // Campaign deadlines arrive as Unix seconds; section settings as an ISO date string
    var end = /^\d+$/.test(raw) ? parseInt(raw, 10) * 1000 : Date.parse(raw);
    if (isNaN(end)) return;
    el.setAttribute('data-bw-running', '1');
    var section = el.closest('.bw-li-offer');
    (function tick() {
      if (!el.isConnected) return;
      var left = end - Date.now();
      if (left <= 0) {
        el.textContent = el.getAttribute('data-bw-ended') || 'Offer ended';
        if (section) section.classList.add('is-ended');
        return;
      }
      var mins = Math.floor(left / 60000);
      var d = Math.floor(mins / 1440);
      var h = Math.floor((mins % 1440) / 60);
      var m = mins % 60;
      el.textContent = 'Ends in ' + (d > 0 ? plural(d, 'day') + ' ' + plural(h, 'hr') : plural(h, 'hr') + ' ' + plural(m, 'min'));
      setTimeout(tick, 30000);
    })();
  }

  /* ---------- Wiring ---------- */
  function update() {
    frame = null;
    progressNavs.forEach(updateProgress);
    stickyBars.forEach(updateSticky);
  }

  function requestUpdate() {
    if (frame === null) frame = window.requestAnimationFrame(update);
  }

  function init() {
    progressNavs = Array.prototype.map.call(document.querySelectorAll('[data-bw-progress]'), setupProgress);
    stickyBars = Array.prototype.map.call(document.querySelectorAll('[data-bw-sticky]'), setupSticky);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bw-deadline]'), startCountdown);
    requestUpdate();
  }

  // Capture phase catches scrolling on the window or on any inner scroll container
  document.addEventListener('scroll', requestUpdate, { capture: true, passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
